import * as React from 'react';

import type Moment from 'moment';

// @ts-expect-error
import {WEEK, MONTH} from './calendar-constants';
import {CalendarDates} from './calendar-dates';
// @ts-expect-error
import {CalendarHeader} from './calendar-header';
import {DayOfWeekBar} from './day-of-week-bar';
import type {DayDisplayFormat} from './day-of-week-bar';

import styles from './calendar.module.css';

type State = {
    // @ts-expect-error
    momentDisplayDate: Moment;
};

type Props = {
    // @ts-expect-error
    momentDisplayDate: Moment;
    displayMode?: WEEK | MONTH;
    // @ts-expect-error
    onDateClick: (arg1: Moment) => void;
    // @ts-expect-error
    onYearChange?: (arg1: Moment) => void;
    // @ts-expect-error
    selectedDates?: Moment[];
    headerDateFormat?: string;
    dayOfWeekFormat?: DayDisplayFormat;
    isTodayHighlighted?: boolean;
    showAdjacentMonthDates?: boolean;
    minDate?: any;
    maxDate?: any;
    width?: number;
    height?: number;
    // @ts-expect-error
    hoveredDates?: Moment[];
    // @ts-expect-error
    onDateMouseOver?: (arg1: Moment) => void;
    // @ts-expect-error
    onDateMouseOut?: (arg1: Moment) => void;
    // @ts-expect-error
    comparisonDates?: Moment[];
    useComparisonMode?: boolean;
    hasQuickViews?: boolean;
    quickViews?: any;
    hasLeftControl?: boolean;
    hasRightControl?: boolean;
    onLeftControlClick?: () => void;
    onRightControlClick?: () => void;
    isLightMode?: boolean;
    hasYearPicker?: boolean;
};

export class Calendar extends React.Component<Props, State> {
    static defaultProps = {
        hasLeftControl: true,
        hasRightControl: true,
        selectedDates: [],
        comparisonDates: [],
    };

    render() {
        return (
            <div
                style={{width: this.props.width, height: this.props.height}}
                className={styles['container']}
            >
                <CalendarHeader
                    isLightMode={this.props.isLightMode}
                    hasYearPicker={this.props.hasYearPicker}
                    hasLeftControl={this.props.hasLeftControl}
                    hasRightControl={this.props.hasRightControl}
                    dateFormat={this.props.headerDateFormat}
                    momentDisplayDate={this.props.momentDisplayDate}
                    onLeftClick={this.props.onLeftControlClick}
                    onRightClick={this.props.onRightControlClick}
                    onYearChange={this.props.onYearChange}
                />
                <DayOfWeekBar
                    displayMode={this.props.displayMode}
                    startOfWeekInt={this.getStartOfWeek()}
                    dateFormat={this.props.dayOfWeekFormat}
                />
                <CalendarDates
                    momentDisplayDate={this.props.momentDisplayDate}
                    displayMode={this.props.displayMode}
                    // @ts-expect-error
                    hasQuickViews={this.props.hasQuickViews}
                    quickViews={this.props.quickViews}
                    selectedDates={this.props.selectedDates}
                    comparisonDates={this.props.comparisonDates}
                    useComparisonMode={this.props.useComparisonMode}
                    hoveredDates={this.props.hoveredDates}
                    onDateMouseOver={this.props.onDateMouseOver}
                    onDateMouseOut={this.props.onDateMouseOut}
                    onDateClick={this.props.onDateClick}
                    minDate={this.props.minDate}
                    maxDate={this.props.maxDate}
                    isTodayHighlighted={this.props.isTodayHighlighted}
                    showAdjacentMonthDates={this.props.showAdjacentMonthDates}
                />
            </div>
        );
    }

    getStartOfWeek = () => {
        if (this.props.displayMode === WEEK) {
            return this.props.momentDisplayDate.clone().subtract(3, 'days').day();
        }

        return 0;
    };
}
